import {createFileRoute} from '@tanstack/react-router';

import {SeverityLibrary} from '@/features/Library/components/Severity/SeverityLibrary';
import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

export const Route = createFileRoute('/_b/_p/_library/severities')({
  component: SeverityLibrary,
  beforeLoad: () => makeDocumentTitle('Severities'),
});
